import React from "react";

function Contacts() {
  return (
    <div className="home">
      <div class="info-page-container">
        <h1>Contacts</h1>
      </div>
      <div class="contacts-container">
        <div class="contacts-col-left">
          <div class="contacts-name">Samu Niskanen</div>
          <div class="contacts-email">samu.niskanen (at) helsinki.fi</div>
        </div>
        <div class="contacts-col-separator"></div>
        <div class="contacts-col-right">
          <div class="contacts-name">Lauri Leinonen</div>
          <div class="contacts-email">lauri.i.leinonen (at) helsinki.fi</div>
        </div>
      </div>
    </div>
  );
}

export default Contacts;